import React, { useState } from 'react';
import { IconFlag } from '@tabler/icons-react';
interface PriorityWidgetProps {
  question: string;
  onSelect: (priority: 'high' | 'medium' | 'low') => void;
}
export function PriorityWidget({
  question,
  onSelect
}: PriorityWidgetProps) {
  const priorities = [{
    id: 'high' as const,
    label: 'Alta',
    color: '#FAD88A',
    description: 'Urgente'
  }, {
    id: 'medium' as const,
    label: 'Media',
    color: '#AEDAFF',
    description: 'Importante'
  }, {
    id: 'low' as const,
    label: 'Bassa',
    color: '#B0EC9C',
    description: 'Quando possibile'
  }];
  return <div className="mt-3 bg-white border border-yeppy-text border-opacity-15 rounded-2xl p-4" data-id="element-440">
      <p className="font-poppins text-sm font-medium mb-3" style={{
      color: '#1D2A36'
    }} data-id="element-441">
        {question}
      </p>
      <div className="space-y-2" data-id="element-442">
        {priorities.map(priority => <button key={priority.id} onClick={() => onSelect(priority.id)} className="w-full px-4 py-3 rounded-2xl font-poppins text-sm font-medium text-yeppy-text bg-yeppy-bg border border-yeppy-text border-opacity-10 transition-all active:scale-[0.98] flex items-center gap-3" data-id="element-443">
            <div className="w-3 h-3 rounded-full flex-shrink-0" style={{
          backgroundColor: priority.color
        }} data-id="element-444" />
            <div className="flex-1 text-left" data-id="element-445">
              <div className="font-medium" data-id="element-446">{priority.label}</div>
              <div className="text-xs text-yeppy-text text-opacity-60" data-id="element-447">
                {priority.description}
              </div>
            </div>
            <div className="flex items-center gap-2 mb-3" data-id="element-448">
              <div className="w-8 h-8 rounded-lg bg-white bg-opacity-50 flex items-center justify-center flex-shrink-0" data-id="element-449">
                <IconFlag className="w-4 h-4 text-yeppy-text" stroke={1.5} data-id="element-450" />
              </div>
              <h4 className="font-rubik font-medium text-sm text-yeppy-text" data-id="element-451">
                {priority.label}
              </h4>
            </div>
          </button>)}
      </div>
    </div>;
}